import "next/style/vendors/_font-source-sans.css"
import "next/style/vendors/_fontawesome.scss"
import "next/style/pages/_tier_features.scss"
import "next/style/pages/preise-tailwind.css"
import 'utils/rails'
import 'controllers/tier-public'

document.addEventListener("DOMContentLoaded", async () => {
  const selectors = ["hrfilter-news-block", "network-graph"]
  const needsAutomount = selectors.some(s => document.querySelector(s))
  if (!needsAutomount) return

  const { default: Automount } = await import("utils/automount-next")
  Automount("hrfilter-news-block", () => import('prelogin/HrfilterNewsBlock.vue'))
  Automount("network-graph", () => import('prelogin/NetworkGraph.vue'))
})
